export default __webpack_public_path__ + "static/media/ban-mobile-image-6.d34ae99f.jpg";